import React from 'react';
import { Text, Stack, Container, List } from 'basis';
import { initFormConfig } from 'utils';
import { DvsConsent } from 'components/idv-consent/DvsConsent';

export const initialValues = {
  dvsConsent: false,
};

export const getFormConfig = storeState =>
  initFormConfig([
    {
      component: 'InfoBlock',
      name: 'intro',
      children: (
        <Container padding="2 0 8 0">
          <Stack gap="5">
            <Text>
              As part of your application, we’ll attempt to verify your identity using one of the following valid ID
              documents:
            </Text>
            <List>
              {!storeState?.hasUpfrontDriversLicence && <List.Item>New Zealand Driver Licence</List.Item>}
              <List.Item>New Zealand Passport</List.Item>
              <List.Item>New Zealand Birth Certificate</List.Item>
              <List.Item>New Zealand Citizenship</List.Item>
              <List.Item>Australian Passport</List.Item>
            </List>
            <Text>
              If you don’t hold a valid ID document, you can skip this process by selecting ‘None’ in the next step.
            </Text>
          </Stack>
        </Container>
      ),
    },
    {
      component: 'CustomComponent',
      name: 'dvsConsent',
      children: DvsConsent,
    },
  ]);
